import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "10%"
    }, " Código "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "40%"
    }, " Descrição "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "25%"
    }, " valor "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "25%"
    }, " Ações ")
  ])
], -1)
const _hoisted_2 = { hidden: "" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "bg-primary" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { colspan: "2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "bg-surface mx-auto px-6 py-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Lista Módulos ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    "prepend-icon": "mdi-magnify"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtrar()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Filtar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.novo()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Novo")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_table, {
            density: "compact",
            class: "elevation-1",
            height: "68vh"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modulos.content, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_2, _toDisplayString(i), 1),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.descricao), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.mascaraMoney(item.valor)), 1),
                    _createElementVNode("td", _hoisted_4, [
                      _createVNode(_component_v_icon, {
                        size: "large",
                        icon: "mdi-pencil-box-outline",
                        title: "Alterar",
                        color: "red",
                        onClick: ($event: any) => (_ctx.alterar(item.id))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("tfoot", _hoisted_5, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_6, "Página " + _toDisplayString(_ctx.modulos.number + 1) + " de " + _toDisplayString(_ctx.modulos.totalPages), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_v_pagination, {
                      "v-model": _ctx.paginaAtual + 1,
                      length: _ctx.modulos.totalPages,
                      "total-visible": 7
                    }, null, 8, ["v-model", "length"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}